import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import PageNotFound from 'components/page/page-not-found/PageNotFound';
import ListsDashboard from '../components/lists-dashboard/ListsDashboard';

import { t } from 'utils/language';
import { getCollectionsSubnavigation } from 'utils/navigation';

import type { LocationWindow, Organization } from 'types';

type OwnProps = {
  location: LocationWindow
};

type StateProps = {
  org: Organization
};

type Props = OwnProps & StateProps;

class ListsDashboardPage extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { org, location } = this.props;
    const orgId = org.id;

    if (!orgId) {
      return <PageNotFound />;
    }

    return (
      <Page
        documentTitle={t('lists.browser_title')}
        subnavigation={getCollectionsSubnavigation(orgId)}
      >
        <ListsDashboard
          location={location}
        />
      </Page>
    );
  }
}

const mapStateToProps = ({ organizations }): StateProps => ({
  org: organizations.currentOrganization
});

export default connect(mapStateToProps)(ListsDashboardPage);
